export function leadJaVirouPedido(lead: unknown): boolean {
  if (!lead || typeof lead !== 'object') return false;
  const { pedido_id, status_lead } = lead as { pedido_id?: string | null; status_lead?: string | null };
  if (pedido_id) return true;
  return ['CONVERTIDO', 'CARTEIRIZADO'].includes(String(status_lead ?? '').toUpperCase());
}
